import axios from 'axios'
import { Message } from 'element-ui'
import Router from '@/router/index'
import { getStore } from '@/utils/common'
const httpService = axios.create({
  baseURL: window.baseUrl || process.env.VUE_APP_BASE_API,
  // baseURL: "https://zljtproapi.cailian.net",
  timeout: 20000
});
httpService.interceptors.request.use(config => {
  let token = getStore('token')
  // token = '48360dd3-e944-44a3-b31a-6405e6aeb488'
  if (token && !config.url.includes('/oauth/token')) {
    config.headers.authorization = 'bearer ' + token;
  } else {
    config.headers.authorization = "Basic d2ViQXBwOndlYkFwcA==";
  }
  return config;
}, err => {
  return Promise.reject(err);//请求错误时，直接结束
});

httpService.interceptors.response.use(response => {
  return response.data;
}, error => {
  if (error.response) {
    switch (error.response.status) {
      case 400: Message.error('请求错误(400)'); break;
      case 401:
        localStorage.clear();
        sessionStorage.clear();
        if (window.self === window.top) {
          Router.push('/login')
        }
        Message.error('登录过期，请重新登录');
        break;
      case 403: Message.error('拒绝访问(403)'); break;
      case 404: Message.error(`请求出错(404)`); break;
      case 408: Message.error('请求超时(408)'); break;
      case 500: Message.error('服务器错误(500)'); break;
      case 501: Message.error('服务未实现(501)'); break;
      case 502: Message.error('网络错误(502)'); break;
      case 503: Message.error('服务不可用(503)'); break;
      case 504: Message.error('网络超时(504)'); break;
      case 505: Message.error('HTTP版本不受支持(505)'); break;
      default: Message.error(`连接出错(${error.response.status})!`);
    }
  }
  return Promise.reject(error.response ? error.response.data : {})
});

export default httpService
